module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-thinking.12d26890.png";